import gql from 'graphql-tag';

export const rejectFeedPostMutation = gql`
  mutation rejectFeedPost($feedItemId: String!, $rejectionReason: String!) {
    rejectFeedPost(feedItemId: $feedItemId, rejectionReason: $rejectionReason)
  }
`;
